






























































































































































import Vue from 'vue'
let darkMode: Boolean | null = null
export default Vue.extend({
  props: {
    showBackButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      darkMode,
    }
  },
  mounted() {
    if (darkMode === null) {
      darkMode = this.$cookies.isDarkMode
      if (darkMode) {
        document.documentElement.classList.add('dark')
        document.cookie = `darkMode=${darkMode}; Secure; max-age=31536000; path=/;`
      }
    }
    document.documentElement.classList.remove('hidden')
  },
  methods: {
    toggleDarkMode() {
      darkMode = !darkMode
      document.documentElement.classList[darkMode ? 'add' : 'remove']('dark')
      document.cookie = `darkMode=${darkMode}; Secure; max-age=31536000; path=/;`
    },
  },
})
